var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 14,
    viewBox: "0 0 17 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 1.65737C16.3679 1.93848 15.6942 2.12477 14.9919 2.21521C15.7144 1.778 16.2658 1.0909 16.5251 0.262786C15.8515 0.669818 15.1077 0.957374 14.3151 1.11786C13.6755 0.427535 12.7638 0 11.7693 0C9.83978 0 8.28642 1.58744 8.28642 3.53341C8.28642 3.81337 8.30984 4.0826 8.36723 4.33894C5.46969 4.19573 2.90586 2.78814 1.1836 0.644008C0.88295 1.17281 0.706545 1.778 0.706545 2.4295C0.706545 3.65288 1.32807 4.73744 2.25456 5.36521C1.69464 5.35449 1.1453 5.18974 0.67995 4.93018V4.9689C0.67995 6.68549 1.88799 8.1114 3.47225 8.43986C3.18854 8.51844 2.87937 8.55611 2.55849 8.55611C2.33537 8.55611 2.11009 8.54321 1.89867 8.49585C2.35026 9.89481 3.63161 10.9233 5.15528 10.9566C3.96953 11.8968 2.46392 12.4632 0.834074 12.4632C0.548211 12.4632 0.274054 12.4503 0 12.4147C1.5438 13.4238 3.37336 14 5.34647 14C11.7598 14 15.266 8.61543 15.266 3.94804C15.266 3.79182 15.2607 3.64112 15.2533 3.49136C15.945 2.99389 16.5261 2.37247 17 1.65737Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.2d3424fe.svg";
export { ForwardRef as ReactComponent };